module.exports = __webpack_public_path__ + "assets/img/pizza_3.38f3a93f.png";